export const CATEGORIES = [
  "Gestione obiezioni",
  "Tecniche di chiusura",
  "Value proposition",
  "Gestione prezzo",
  "Fasi della trattativa",
  "Altro",
];

// --- KB strutturata a cluster (7 fasi fisse) ---
export const FASI = [
  "apertura",
  "scoperta_bisogni",
  "presentazione_valore",
  "gestione_obiezioni",
  "gestione_prezzo",
  "chiusura",
  "follow_up",
];

export const FASE_LABEL = {
  apertura: "Apertura",
  scoperta_bisogni: "Scoperta bisogni",
  presentazione_valore: "Presentazione valore",
  gestione_obiezioni: "Gestione obiezioni",
  gestione_prezzo: "Gestione prezzo",
  chiusura: "Chiusura",
  follow_up: "Follow-up",
};

export const FASE_STYLE = {
  apertura: { bg: "rgba(96,165,250,0.15)", text: "#93C5FD", border: "rgba(96,165,250,0.3)", bar: "#60A5FA" },
  scoperta_bisogni: { bg: "rgba(52,211,153,0.15)", text: "#6EE7B7", border: "rgba(52,211,153,0.3)", bar: "#34D399" },
  presentazione_valore: { bg: "rgba(147,197,253,0.15)", text: "#BFDBFE", border: "rgba(147,197,253,0.3)", bar: "#93C5FD" },
  gestione_obiezioni: { bg: "rgba(239,68,68,0.15)", text: "#FCA5A5", border: "rgba(239,68,68,0.3)", bar: "#EF4444" },
  gestione_prezzo: { bg: "rgba(245,158,11,0.15)", text: "#FCD34D", border: "rgba(245,158,11,0.3)", bar: "#F59E0B" },
  chiusura: { bg: "rgba(16,185,129,0.15)", text: "#6EE7B7", border: "rgba(16,185,129,0.3)", bar: "#10B981" },
  follow_up: { bg: "rgba(148,163,184,0.15)", text: "#CBD5E1", border: "rgba(148,163,184,0.3)", bar: "#94A3B8" },
};

export const MOMENTO_LABEL = {
  prima_call: "1ª call",
  seconda_call: "2ª call",
  call_avanzata: "Call avanzata",
  trasversale: "Trasversale",
};

export const TIPO_LABEL = { script: "Script", linea_guida: "Linea guida" };

export const OBIEZIONE_TAGS = ["prezzo", "tempo", "fiducia", "ci_penso", "concorrenza", "bisogno_non_percepito"];
export const OBIEZIONE_LABEL = {
  prezzo: "Prezzo",
  tempo: "Tempo",
  fiducia: "Fiducia",
  ci_penso: "Ci penso",
  concorrenza: "Concorrenza",
  bisogno_non_percepito: "Bisogno non percepito",
};

export const CATEGORY_STYLE = {
  "Gestione obiezioni": { bg: "rgba(239,68,68,0.15)", text: "#FCA5A5", border: "rgba(239,68,68,0.3)", bar: "#EF4444" },
  "Tecniche di chiusura": { bg: "rgba(16,185,129,0.15)", text: "#6EE7B7", border: "rgba(16,185,129,0.3)", bar: "#10B981" },
  "Value proposition": { bg: "rgba(37,99,235,0.15)", text: "#93C5FD", border: "rgba(37,99,235,0.3)", bar: "#2563EB" },
  "Gestione prezzo": { bg: "rgba(245,158,11,0.15)", text: "#FCD34D", border: "rgba(245,158,11,0.3)", bar: "#F59E0B" },
  "Fasi della trattativa": { bg: "rgba(20,184,166,0.15)", text: "#5EEAD4", border: "rgba(20,184,166,0.3)", bar: "#14B8A6" },
  Altro: { bg: "rgba(107,114,128,0.15)", text: "#D1D5DB", border: "rgba(107,114,128,0.3)", bar: "#6B7280" },
  // Etichette fase (usate dai badge fonte in Live/Coach/Report)
  Apertura: { bg: "rgba(96,165,250,0.15)", text: "#93C5FD", border: "rgba(96,165,250,0.3)", bar: "#60A5FA" },
  "Scoperta bisogni": { bg: "rgba(52,211,153,0.15)", text: "#6EE7B7", border: "rgba(52,211,153,0.3)", bar: "#34D399" },
  "Presentazione valore": { bg: "rgba(147,197,253,0.15)", text: "#BFDBFE", border: "rgba(147,197,253,0.3)", bar: "#93C5FD" },
  Chiusura: { bg: "rgba(16,185,129,0.15)", text: "#6EE7B7", border: "rgba(16,185,129,0.3)", bar: "#10B981" },
  "Follow-up": { bg: "rgba(148,163,184,0.15)", text: "#CBD5E1", border: "rgba(148,163,184,0.3)", bar: "#94A3B8" },
};

export const STATI = ["CARICATO", "IN_TRASCRIZIONE", "IN_ANALISI", "INDICIZZATO"];

export const STATO_STYLE = {
  CARICATO: { bg: "rgba(107,114,128,0.2)", text: "#9CA3AF", label: "Caricato" },
  IN_TRASCRIZIONE: { bg: "rgba(59,130,246,0.2)", text: "#60A5FA", label: "In trascrizione" },
  IN_ANALISI: { bg: "rgba(20,184,166,0.2)", text: "#5EEAD4", label: "In analisi" },
  INDICIZZATO: { bg: "rgba(16,185,129,0.2)", text: "#34D399", label: "Indicizzato" },
  ERRORE: { bg: "rgba(239,68,68,0.2)", text: "#F87171", label: "Errore" },
  NON_PERTINENTE: { bg: "rgba(245,158,11,0.2)", text: "#FCD34D", label: "Non pertinente" },
};

export const isProcessing = (stato) => ["CARICATO", "IN_TRASCRIZIONE", "IN_ANALISI"].includes(stato);

export const formatDate = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const slugify = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-");
